import React, { useEffect, useMemo, useState } from 'react';
import { fetchSessions } from '../../config';
import './AcceptedSessionsSection.css';

const AcceptedSessionsSection = () => {
  const [miniItems, setMiniItems] = useState([]);
  const [specialItems, setSpecialItems] = useState([]);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const loadSessions = async () => {
      try {
        const { miniSymposia, specialSessions } = await fetchSessions();
        if (cancelled) return;
        const miniMapped = Array.isArray(miniSymposia) ? miniSymposia : [];
        const specialMapped = Array.isArray(specialSessions) ? specialSessions : [];
        setMiniItems(miniMapped);
        setSpecialItems(specialMapped);
        setVisible(miniMapped.length > 0 || specialMapped.length > 0);
      } catch (e) {
        if (cancelled) return;
        console.error('Failed to fetch accepted sessions', e);
        setMiniItems([]);
        setSpecialItems([]);
        setVisible(false);
      }
    };

    loadSessions();
    return () => { cancelled = true; };
  }, []);

  const hasTypeMini = useMemo(() => miniItems.some(i => i.type), [miniItems]);
  const hasConvenorsMini = useMemo(() => miniItems.some(i => i.convenors), [miniItems]);
  const hasTypeSpecial = useMemo(() => specialItems.some(i => i.type), [specialItems]);
  const hasConvenorsSpecial = useMemo(() => specialItems.some(i => i.convenors), [specialItems]);

  if (!visible) return null;

  return (
    <section className="accepted-sessions section fade-in-up" id="accepted-sessions">
      <div className="container">
        <div className="accepted-sessions-header">
          <h2 className="section-title">Accepted Mini-symposia and Special Sessions</h2>
        </div>
        <p className="section-subtitle">Explore the accepted session topics below. New sessions are added as they are confirmed.</p>
        <div className="sessions-grid">
          {miniItems.length > 0 && (
            <div className="session-card">
              <h3 className="session-card-title">Mini-symposia</h3>
              <div className="table-wrapper">
                <table className="accepted-sessions-table">
                  <tbody>
                    {miniItems.map((row, idx) => (
                      <tr key={`mini-${idx}`}>
                        <td>{row.topic}</td>
                        {hasTypeMini && <td>{row.type || '-'}</td>}
                        {hasConvenorsMini && <td>{row.convenors || '-'}</td>}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {specialItems.length > 0 && (
            <div className="session-card">
              <h3 className="session-card-title">Special Sessions</h3>
              <div className="table-wrapper">
                <table className="accepted-sessions-table">
                  <tbody>
                    {specialItems.map((row, idx) => (
                      <tr key={`special-${idx}`}>
                        <td>{row.topic}</td>
                        {hasTypeSpecial && <td>{row.type || '-'}</td>}
                        {hasConvenorsSpecial && <td>{row.convenors || '-'}</td>}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
        <a href="https://ices2026-portal.com" target="_blank" rel="noopener noreferrer" className="btn btn-primary">Request a Session</a>
      </div>
    </section>
  );
};

export default AcceptedSessionsSection;
